import { isArray } from 'lodash'
import { setNotification } from '../store/userProfile'

// HACK: remove __typename from object
// This can be useful when you attempt to use a GQL output as an input
// GQL will fail if you pass in an explicit __typename which does not match
// https://github.com/apollographql/apollo-client/issues/1564#issuecomment-357492659
export function omitTypenameDeep(obj) {
  return JSON.parse(JSON.stringify(obj), (key, value) =>
    key === '__typename' ? undefined : value,
  )
}
export const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]))
  } catch {
    return null
  }
}

export const getUserInfo = (state) => {
  const { userProfile } = state
  return parseJwt(userProfile?.token)
}
export const getFlagInfo = (features, featureName) => {
  return features?.some(
    (feature) => feature.feature === featureName && feature.enabled === true,
  )
}

export const userIsInSomeRole = (roles, checkRoleArray) => {
  /* Example
    const rolesArray = ['ADMIN', 'SUPPORT', 'MAINTAINER'];
    const checkRoleArray = ['ADMIN', 'MAINTAINER'];
    console.log(userIsInSomeRole(rolesArray, checkRoleArray)) */
  if (isArray(roles)) {
    return checkRoleArray.some((arrRole) => roles.includes(arrRole))
  } else {
    /* Example
    const singleRole = 'SUPPORT';
    console.log(userIsInSomeRole(singleRole, checkRoleArray)) */
    return checkRoleArray.includes(roles)
  }
}

export const localStorageData = {
  set(key, value) {
    localStorage.setItem(key, value)
  },
  get(key) {
    const stored = localStorage.getItem(key)
    return stored == null ? undefined : JSON.parse(stored)
  },
  remove(key, value) {
    localStorage.removeItem(key)
  },
}

export const truncateString = (str, maxLength) => {
  if (str.length > maxLength) {
    return str.substring(0, maxLength - 3) + '...'
  }
  return str
}

/**
 * Initialize default message to any select
 */
export function initializeDefaultMessageToSelect(isDefaultDisabled) {
  let options = []
  options.push({
    label: 'Choose Type',
    value: '',
    disabled: isDefaultDisabled,
  })
  return options
}
//Cookie.get('name')
//Cookie.set('name', 'value', {path: '/', days: 10})
//Cookie.delete('name', { path: '', domain: '.partnersonline.com' })
export const Cookie = {
  get: (name) => {
    let c = document.cookie.match(
      `(?:(?:^|.*; *)${name} *= *([^;]*).*$)|^.*$`,
    )[1]
    if (c) return decodeURIComponent(c)
  },
  set: (name, value, opts = {}) => {
    /*If options contains days then we're configuring max-age*/
    if (opts.days) {
      opts['max-age'] = opts.days * 60 * 60 * 24
      delete opts.days
    }
    opts = Object.entries(opts).reduce(
      (accumulatedStr, [k, v]) => `${accumulatedStr}; ${k}=${v}`,
      '',
    )

    document.cookie = name + '=' + encodeURIComponent(value) + opts
  },
  delete: (name, opts) => Cookie.set(name, '', { 'max-age': -1, ...opts }),
  // path & domain must match cookie being deleted
}
export const isSSOSessionActive = (session, dispatch) => {
  const ssoSessionInfo = Cookie.get('SSOSESSIONINFO')
  if (ssoSessionInfo && session) {
    const sessionInfo = window.atob(ssoSessionInfo)
    const sessionInfoObj = JSON.parse(sessionInfo)
    const lanId = session && session.lanId ? session.lanId : null //parseJwt(session)
    const differentUser =
      lanId &&
      sessionInfoObj.user &&
      String(lanId) !== String(sessionInfoObj.user)
    if (differentUser) {
      dispatch(
        setNotification({
          show: true,
          msg: 'Session Expired or Company Changed!',
          isError: true,
        }),
      )
      setTimeout(() => {
        forceSignOut()
      }, 3000)
      return false
    }
  }
  return true
}
const forceSignOut = () => {
  localStorage.removeItem('id_token')
  localStorage.removeItem('access_token')
  Cookie.delete('SSOSESSIONINFO')
  window.location.reload(true)
}
